<template>
    <v-autocomplete v-model="selected" :items="applications" :class="`autcomplete-applications-${className}`" :menuProps="{ attach: `.autcomplete-applications-${className}` }" multiple return-object item-value="_id" v-bind="attrs_input" @change="emit">
        <template #selection="{ item, parent }">
            <v-chip label outlined close @click:close="parent.selectItem(item)" @select="parent.selectItem(item)"> {{ item?.resume?.personalInformation?.name }} / {{ item?.resume?.personalInformation?.genderText }} / {{ item?.resume?.personalInformation?.age }} </v-chip>
        </template>
        <template #item="{ item }">
            <application-card :value="item" v-bind="{ recruitment }" selectable :isSelected="selected.some(({ _id }) => _id == item._id)" width="100%" class="ma-10" />
        </template>
    </v-autocomplete>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables";

import ApplicationCard from "../../application/application-card.vue";

export default {
    components: {
        ApplicationCard,
    },
    props: {
        value: { type: Array, default: () => [] }, // applications
        recruitment: { type: Object, default: () => ({}) },
    },
    data: () => ({
        selected: [],
        applications: [],

        attrs_input,
        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.sync();
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.selected = [...this.value];
        },
        emit() {
            this.$emit("input", this.selected);
        },
        async init() {
            const { applications } = await api.v1.company.recruitments.applications.gets({
                _recruitment: this.recruitment?._id,
            });
            this.applications = applications;
        },
    },
};
</script>

// <style lang="scss" scoped>
// ::v-deep {
//     div[role="option"] {
//         padding: 0;
//     }
// }
//
</style>
